import React, {Component} from 'react';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../constants/configs';
import ReactTableSelectFilter from "../../components/ReactTableSelectFilter";
import {getStatusColor, i18nizeDate, mapStatus, numberWithCommas} from "../../helpers/Utils";
import ReactTableTextFilter from "../../components/ReactTableTextFilter";
import {keyBy, mapValues, omit} from "lodash";
import Api from "../../services/Api";

class JobRuns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      pages: -1,
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  fetchData = async state => {
    const {userId} = this.props;
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/transfers/jobs/runs',
        null,
        {
          params: {
            userId,
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'timestamp') : null),
          }
        },
      );
      this.setState({
        data: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('Id'),
      accessor: 'trackingId',
      Filter: ReactTableTextFilter,
      filterable: true,
      width: 200,
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      Cell: props => {
        return (
          <span>{`${numberWithCommas(Number(props.value))} ${t(props.original.token)}`}</span>
        );
      },
    },
    {
      Header: t('Fee'),
      accessor: 'fee',
      Cell: props => {
        return (
          <span>{`${numberWithCommas(Number(props.value))} ${t(props.original.token)}`}</span>
        );
      },
    },
    {
      Header: t('URL Code'),
      accessor: 'info.urlCode',
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getStatusColor(props.value)}>{mapStatus(props.value)}</span>,
      width: 200,
    },
    {
      Header: t('Start Date'),
      accessor: 'startedAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 200,
    },
    {
      Header: t('End date'),
      accessor: 'endAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 200,
    }
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'SUBMITTED', label: t('Submitted')},
      {value: 'PROCESSING', label: t('Processing')},
      {value: 'DONE', label: t('Done')},
      {value: 'FAILED', label: t('Failed')},
      {value: 'AUTH_ERROR', label: 'AUTH_ERROR'},
      {value: 'SOURCE_CANCEL', label: 'SOURCE_CANCEL'},
      {value: 'LOW_BALANCE', label: 'LOW_BALANCE'},
      {value: 'LOW_BALANCE_FOR_FEE', label: 'LOW_BALANCE_FOR_FEE'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  render() {
    const {t} = this.props;
    const {data, loading, pages} = this.state;
    return (
      <ReactTable
        manual
        data={data}
        pages={pages}
        loading={loading}
        onFetchData={this.fetchData}
        columns={this.getColumns(t)}
        ref={el => {this.table = el;}}
        className="-highlight"
        defaultPageSize={10}
        sortable={false}
        resizable={true}
        style={{
          width: '100%',
          marginTop: 20,
          marginBottom: 10,
        }}
        {...reactTableText}
      />
    );
  }
}

export default withTranslation()(JobRuns);
